import React, {useContext} from "react"
import Row from "@amzn/meridian/row";
import {RouteStageContext} from "./context/RouteStageContext";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {AR, CART_VIEW, ROUTE_VIEW} from "../util/Constants";
import {StageFilterContext} from "./context/StageFilterContext";
import {INTERIM_STAGED, PARTIALLY_STAGED, PRE_STAGED, STAGE_STATUS, STAGED} from "../util/EntityStatusManager";
import Box from "@amzn/meridian/box";
import StageStatusViewV2 from "./StageStatusViewV2";
import ActionableMetricView from "./ActionableMetricView";
import {calculateOTSMetric, isARorSSD} from "../util/Util";
import {applyGlobalStageLocationTypeFilter} from "../util/FilterUtil";
import {DWPFileContext} from "../fileupload/context/DWPUploadContext";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Tooltip from "@amzn/meridian/tooltip";
import DWPUpload from "../fileupload/DWPUpload";
import {FormattedMessage} from "react-intl";
import ScrollableElementWrapper from "../common/ScrollableElementWrapper";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const StageOverallStatusV2 = () => {

    const {viewModel} = useContext(RouteStageContext)
    const {configViewModel} = useContext(CapabilityContext)
    const {viewModelF, dispatchF} = useContext(StageFilterContext)
    const {viewModelDWP} = useContext(DWPFileContext);
    const {spacingInset_shorthand4} = useDeviceLayout()

    let routeList = Array.from(viewModel.routeList);

    const filterOption = (route, filter, key) => {
        if (!viewModelF[filter] || viewModelF[filter].length === 0) {
            return true;
        }
        let result = false;
        viewModelF[filter].forEach(filterValue => {
            if (filter === 'status') {
                result = result || route[key] === filterValue;
            } else if (route[key].includes(filterValue)) {
                result = true;
            }
        })
        return result;
    }

    routeList = routeList
        .filter(route => filterOption(route, "cluster", "routeCode"))
        .filter(route => filterOption(route, "driverType", "routeType"))
        .filter(route => filterOption(route, "departure", "routeSLA"));
    if (viewModelF.viewType === ROUTE_VIEW || !configViewModel.stationConfig.pickStageDecoupleEnabled) {
        routeList = routeList
            .filter(route => filterOption(route, "status", "stageStatus"))
            .filter(route => applyGlobalStageLocationTypeFilter(viewModelF, route));
    }

    const getStageMetrics = (routes) => {
        const metrics = {
            totalRoutes: routes.length,
            notReadyRoutes: 0,
            readyRoutes: 0,
            preStagedRoutes: 0,
            stagedRoutes: 0,
            partialStagedRoutes: 0,
            interimStagedRoutes: 0,
            stagedCarts: 0,
            preStagedCarts: 0,
            dwellingCartsDSP: 0,
            dwellingCartsFlex: 0,
            otsMetric: "-"
        }
        routes.forEach(route => {
            if (route.stageStatus === STAGE_STATUS.STAGED) {
                metrics.stagedRoutes++;
            } else if (route.stageStatus === STAGE_STATUS.PARTIALLY_STAGED) {
                metrics.partialStagedRoutes++;
            } else if (route.stageStatus === STAGE_STATUS.PRE_STAGED) {
                metrics.preStagedRoutes++;
            } else if (route.stageStatus === STAGE_STATUS.READY) {
                metrics.readyRoutes++;
            } else if (route.stageStatus === STAGE_STATUS.NOT_READY) {
                metrics.notReadyRoutes++;
            } else if (route.stageStatus === INTERIM_STAGED) {
                metrics.interimStagedRoutes++;
            }

            let cartList = Array.isArray(route.carts) ? route.carts : [];
            cartList = cartList.filter(cart => filterOption(cart, "status", "status"))
            cartList.forEach(cart => {
                if (cart.status === STAGED) {
                    metrics.stagedCarts++;
                } else if (cart.status === PRE_STAGED) {
                    metrics.preStagedCarts++;
                }
            });
            metrics.dwellingCartsDSP += cartList.filter(cart => ((cart.dwelling === true) && cart.routeType.startsWith("DSP"))).length;
            metrics.dwellingCartsFlex += cartList.filter(cart => ((cart.dwelling === true) && !cart.routeType.startsWith("DSP"))).length;
        });
        metrics.otsMetric = calculateOTSMetric(routes);
        return metrics
    }

    const renderDWPUploadView = () => {
        return <Column minWidth="15%" maxWidth="25%"  spacingInset={"small"} spacing="none" backgroundColor="secondary">
            <Row spacing="none" wrap={"down"}>
                <Text type="h100">
                    <FormattedMessage id="stage.dwpLoaded" defaultMessage="Dispatch plan"/>:&nbsp;
                </Text>
                <Tooltip position="top" title={viewModelDWP.fileName}>
                    <Text type="b300">{viewModelDWP.fileName && viewModelDWP.fileName.length > 28 ?
                        viewModelDWP.fileName.substr(0, 28) + "..." : viewModelDWP.fileName}
                    </Text>
                </Tooltip>
            </Row>
            <Row spacing="none">
                <Text type="h100">
                    <FormattedMessage id="stage.dwpTime" defaultMessage="Last update"/>:&nbsp;
                </Text>
                <Text type="b300">{viewModelDWP.creationTime}</Text>
            </Row>
            <DWPUpload/>
        </Column>
    }


    let stageMetrics = getStageMetrics(routeList);

    return (
        <Row  spacingInset={spacingInset_shorthand4}  spacing="medium"  alignmentVertical="stretch">
            {/* ROUTE VIEW METRICS */}
            {viewModelF.viewType === ROUTE_VIEW || !configViewModel.stationConfig.pickStageDecoupleEnabled ?
                <Row  wrap={"down"}  maxWidth="100%">
                    <Box type="outline" spacingInset="medium">
                        <StageStatusViewV2 stageStatus={{
                            title: "depart.totalRoutes",
                            message: "Total routes",
                            value: stageMetrics.totalRoutes
                        }}/>
                    </Box>
                    {(!isARorSSD(configViewModel.capability)) ? <Box type="outline" spacingInset="medium">
                        <StageStatusViewV2 stageStatus={{
                            title: "stageOverall.timelyStaged",
                            message: "Timely staged (%)",
                            tooltip: "% of routes staged on time. This excludes sidelined routes and routes without DPO time.",
                            value: stageMetrics.otsMetric
                        }}/>
                    </Box> : null}
                    <Box type="outline" spacingInset="medium">
                        <ScrollableElementWrapper>
                            <Row alignmentVertical="bottom" width="100%" spacing="large">
                            <ActionableMetricView
                                onMetricCountClick={() => dispatchF({
                                    type: 'SELECT_STATUS',
                                    status: [STAGE_STATUS.NOT_READY]
                                })}
                                stageStatus={{
                                    title: "stageOverall.notReady",
                                    message: "Not ready",
                                    value: stageMetrics.notReadyRoutes
                                }}/>
                            {!configViewModel.stationConfig.pickStageDecoupleEnabled ?
                                <ActionableMetricView
                                    onMetricCountClick={() => dispatchF({
                                        type: 'SELECT_STATUS',
                                        status: [STAGE_STATUS.READY]
                                    })}
                                    stageStatus={{
                                        title: "stageOverall.ready",
                                        message: STAGE_STATUS.READY,
                                        value: stageMetrics.readyRoutes
                                    }}/>
                                : null
                            }
                            {configViewModel.stationConfig.splitStagingEnabled || configViewModel.stationConfig.pickStageDecoupleEnabled ?
                                <ActionableMetricView
                                    onMetricCountClick={() => dispatchF({
                                        type: 'SELECT_STATUS',
                                        status: [STAGE_STATUS.PRE_STAGED]
                                    })}
                                    stageStatus={{
                                        title: "stageOverall.preStaged",
                                        message: "Pre staged",
                                        value: stageMetrics.preStagedRoutes
                                    }}/>
                                : null
                            }
                            {configViewModel.stationConfig.ssdmmotenabled &&
                                <ActionableMetricView
                                    onMetricCountClick={() => dispatchF({
                                        type: 'SELECT_STATUS',
                                        status: [INTERIM_STAGED]
                                    })}
                                    stageStatus={{
                                        title: "stage.interimStaged",
                                        message: "Interim Staged",
                                        value: stageMetrics.interimStagedRoutes
                                    }}/>
                            }
                            <ActionableMetricView
                                onMetricCountClick={() => dispatchF({
                                    type: 'SELECT_STATUS',
                                    status: [PARTIALLY_STAGED]
                                })}
                                stageStatus={{
                                    title: "stage.partiallyStaged",
                                    message: "Partially Staged",
                                    value: stageMetrics.partialStagedRoutes
                                }}/>
                            <ActionableMetricView
                                onMetricCountClick={() => dispatchF({
                                    type: 'SELECT_STATUS',
                                    status: [STAGED]
                                })}
                                stageStatus={{
                                    title: "cartContent.staged",
                                    message: "Staged",
                                    value: stageMetrics.stagedRoutes
                                }}/>
                        </Row>
                        </ScrollableElementWrapper>
                    </Box>

                </Row>
                : null
            }
            {/* DWP upload view*/}
            {(configViewModel.capability === AR) ? renderDWPUploadView() : null}

            {/* CART VIEW METRICS */}
            {viewModelF.viewType === CART_VIEW && configViewModel.stationConfig.pickStageDecoupleEnabled ?
                <Row>
                    <Box type="outline" spacingInset="medium">
                        <StageStatusViewV2 stageStatus={{
                            title: "depart.totalRoutes",
                            message: "Total routes",
                            value: stageMetrics.totalRoutes
                        }}/>
                    </Box>
                    <Box type="outline" spacingInset="medium">
                        <Row width="100%" spacing="large">
                            <ActionableMetricView
                                onMetricCountClick={() => dispatchF({
                                    type: 'SELECT_STATUS',
                                    status: [PRE_STAGED]
                                })}
                                stageStatus={{
                                    title: "stageOverall.cartPreStaged",
                                    message: "Carts Pre Staged",
                                    value: stageMetrics.preStagedCarts
                                }}/>
                            <ActionableMetricView
                                onMetricCountClick={() => dispatchF({
                                    type: 'SELECT_STATUS',
                                    status: [STAGED]
                                })}
                                stageStatus={{
                                    title: "stageOverall.cartsStaged",
                                    message: "Carts Staged",
                                    value: stageMetrics.stagedCarts
                                }}/>
                            <ActionableMetricView
                                onMetricCountClick={() => {
                                    dispatchF({type: 'SELECT_STATUS', status: [PRE_STAGED]})
                                    dispatchF({type: 'SELECT_DRIVER_TYPE', DriverType: ["DSP"]})
                                }}
                                stageStatus={{
                                    title: "stageOverall.cartDwellingDSP",
                                    message: "Carts Dwelling (DSP)",
                                    value: stageMetrics.dwellingCartsDSP
                                }}/>
                            <ActionableMetricView
                                onMetricCountClick={() => {
                                    dispatchF({type: 'SELECT_STATUS', status: [PRE_STAGED]})
                                    dispatchF({type: 'SELECT_DRIVER_TYPE', DriverType: ["DP"]})
                                }}
                                stageStatus={{
                                    title: "stageOverall.cartDwellingFlex",
                                    message: "Carts Dwelling (Flex)",
                                    value: stageMetrics.dwellingCartsFlex
                                }}/>
                        </Row>
                    </Box>
                </Row> : null
            }
        </Row>
    )
}

export default StageOverallStatusV2


// WEBPACK FOOTER //
// ./src/components/stageStatus/StageOverallStatusV2.js